<template>
  <v-dialog max-width="300" v-model="dialog.shows.showInfo">
    <v-card>
      <v-card-text>
        <div class="body-1 font-weight-bold">
          <br>
          <h4>
            {{ $vuetify.lang.t(dialog.title) }}
          </h4>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog.shows.showInfo = false" text>{{ $vuetify.lang.t('$vuetify.btn.close') }}</v-btn>
        <v-btn
          :loading="loadingBtn"
          @click="sendForm"
          color="secondary"
          text
        >{{ $vuetify.lang.t(dialog.saveBtnTitle) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import URLPath from "../../helpers/URL";
  import FormMixin from '../../mixins/Common/Forms';

  export default {
    mixins: [FormMixin],
    name: "Infos",
    props: {
      dialog: {
        type: Object,
        default: function () {
          return {
            title: "$vuetify.users.new.title",
            shows: {
              showInfo: false
            },
            saveBtnTitle: "$vuetify.btn.save",
            action: "create"
          };
        }
      },
      form: {
        type: Object,
        default: function () {
          return {
            name: null,
            shortName: null,
            description: null,
            user: null,
            email: null
          };
        }
      }
    },
    data: () => ({
      loadingBtn: false
    }),
    methods: {
      sendForm() {
        let self = this;
        this.loadingBtn = true;
        this.save(this.getFormParam())
          .then(() => {
            this.$emit("getItems");
            let message = self.$vuetify.lang.t("$vuetify.success_form");
            if (self.dialog.action === "delete") message = self.$vuetify.lang.t("$vuetify.delete_form");
            self.$store.dispatch("setNotification", {
              status: true,
              message: message
            });
          }).catch(() => {
        }).finally(() => {
          self.loadingBtn = false;
          self.dialog.shows.showInfo = false;
        })
      },
      setForm(item) {
        this.form["id"] = item.id;
        this.form.user = item.id;
        this.form["shortName"] = item.shortName;
        this.form.name = item.name;
        this.form.shortName = item.shortName;
        this.form.description = item.description;
        this.form.email = item.email;
        this.form["active"] = item.active;
        this.form["notificationActive"] = item.notificationActive;
        this.form["notificationEmailActive"] = item.notificationEmailActive;
      },
      getFormParam() {
        let params = {};
        switch (this.dialog.action) {
          case "active":
            params["url"] = URLPath.APPLICATION.EDIT.URI.replace(
              "{APPLICATION_ID}",
              this.form["id"]
            );
            params["method"] = URLPath.APPLICATION.EDIT.METHOD;
            this.form["active"] = (!this.form["active"]);
            params["data"] = this._.omit(this.form, ['id']);
            break;
          case "notification":
            params["url"] = URLPath.APPLICATION.EDIT.URI.replace(
              "{APPLICATION_ID}",
              this.form["id"]
            );
            params["method"] = URLPath.APPLICATION.EDIT.METHOD;
            this.form["notificationActive"] = (!this.form["notificationActive"]);
            params["data"] = this._.omit(this.form, ['id']);
            break;
          case "notificationEmail":
            params["url"] = URLPath.APPLICATION.EDIT.URI.replace(
              "{APPLICATION_ID}",
              this.form["id"]
            );
            params["method"] = URLPath.APPLICATION.EDIT.METHOD;
            this.form["notificationEmailActive"] = (!this.form["notificationEmailActive"]);
            params["data"] = this._.omit(this.form, ['id']);
            break;
          case "delete":
            params["url"] = URLPath.APPLICATION.DELETE.URI.replace(
              "{APPLICATION_ID}",
              this.form["id"]
            );
            params["method"] = URLPath.APPLICATION.DELETE.METHOD;
            params["data"] = {};
            break;
          case "new-secret":
            params["url"] = URLPath.APPLICATION.SECRET.URI.replace(
              "{APPLICATION_ID}",
              this.form["id"]
            );
            params["method"] = URLPath.APPLICATION.SECRET.METHOD;
            params["data"] = {};
            break;
        }
        return params;
      },
    }
  }
</script>
